module.exports = __webpack_public_path__ + "img/lums.83a18906.png";